// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.ai_workshop {
  background-color: #fefebe;
  padding: 5% 13%;
}
section.ai_workshop .container {
  display: flex;
  flex-direction: row-reverse;
}

.tpdp-heading {
  font-size: 40px;
}

.waht_teacher_pdp {
  font-size: 18px;
  padding: 5% 10%;
  font-weight: 500;
  text-align: justify;
  letter-spacing: 0.5px;
  word-spacing: 1px;
}

.tpdp-content {
  padding-left: 3rem;
}

.tpdp-content p {
  text-align: justify !important;
}

.gpt_workshop {
  background: #6e5aca;
  padding: 3% 10%;
}

.gpt_workshop h2,
.gpt_workshop p,
.gpt_workshop li {
  color: #ffffff;
}
.gpt_workshop li,
.gpt_workshop p {
  font-size: 18px;
}
.gpt_workshop span {
  display: inline-block;
  font-weight: 600;
  margin-bottom: 20px;
  background-color: #5bbca5;
  padding: 5px 15px;
  color: #ffffff;
}

.ai_workshop h2 {
  font-size: 32px;
  font-weight: 500;
}

.ai_workshop p {
  text-align: justify;
  font-size: 18px;
}

.ai_workshop li {
  margin-bottom: 10px;
  font-size: 18px;
}

.ai_workshop img {
  width: 131%;
  object-fit: fill;
}

.ai_workshop .conatiner img {
  height: 100% !important;
  width: auto !important;
}

.ai-workshop-wrapper ul li {
  text-align: justify;
}

.ai_workshop span {
  display: inline-block;
  font-weight: 600;
  margin-bottom: 20px;
  background-color: var(--dPink);
  padding: 5px 15px;
  color: #ffffff;
}

.school_form_submit button {
  border: 0;
  margin-top: 20px;
  margin-bottom: 50px;
  background: #5bbca5;
  color: #ffffff;
  padding: 10px 30px;
  border-radius: 10px;
  font-weight: 700;
}

.ai-workshop-wrapper h2 {
  font-family: "Nasalization";
  font-size: 40px;
}

@media (max-width: 576px) {
  section.ai_workshop .container {
    flex-direction: column;
  }
  .ai_workshop img {
    width: 100%;
  }
  .ai_workshop img {
    width: 100%;
    object-fit: contain;
  }

  .pdp_banner {
    padding: 0 5%;
  }

  .pdp_banner span,
  .pdp_banner_subtxt {
    font-size: 28px;
  }

  .tpdp-heading {
    font-size: 22px;
    padding-top: 20px;
    padding-bottom: 0px;
  }

  .tpdp-content {
    padding-left: 10px;
  }

  .waht_teacher_pdp {
    padding: 5%;
  }

  .gpt_workshop {
    padding: 3%;
  }

  section.ai_workshop {
    padding: 5%;
  }
}

@media (max-width: 820px) {
  .ai_workshop img {
    width: 100%;
    object-fit: contain;
  }

  section.ai_workshop .container {
    flex-wrap: wrap;
  }

  .waht_teacher_pdp img {
    height: 100%;
    object-fit: cover;
  }

  .px-md-5 {
    padding: 0px !important;
  }

  .pt-100 {
    padding-top: 50px !important;
  }

  .teacher-pdp-form .form-control {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TeacherPdp.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["section.ai_workshop {\n  background-color: #fefebe;\n  padding: 5% 13%;\n}\nsection.ai_workshop .container {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.tpdp-heading {\n  font-size: 40px;\n}\n\n.waht_teacher_pdp {\n  font-size: 18px;\n  padding: 5% 10%;\n  font-weight: 500;\n  text-align: justify;\n  letter-spacing: 0.5px;\n  word-spacing: 1px;\n}\n\n.tpdp-content {\n  padding-left: 3rem;\n}\n\n.tpdp-content p {\n  text-align: justify !important;\n}\n\n.gpt_workshop {\n  background: #6e5aca;\n  padding: 3% 10%;\n}\n\n.gpt_workshop h2,\n.gpt_workshop p,\n.gpt_workshop li {\n  color: #ffffff;\n}\n.gpt_workshop li,\n.gpt_workshop p {\n  font-size: 18px;\n}\n.gpt_workshop span {\n  display: inline-block;\n  font-weight: 600;\n  margin-bottom: 20px;\n  background-color: #5bbca5;\n  padding: 5px 15px;\n  color: #ffffff;\n}\n\n.ai_workshop h2 {\n  font-size: 32px;\n  font-weight: 500;\n}\n\n.ai_workshop p {\n  text-align: justify;\n  font-size: 18px;\n}\n\n.ai_workshop li {\n  margin-bottom: 10px;\n  font-size: 18px;\n}\n\n.ai_workshop img {\n  width: 131%;\n  object-fit: fill;\n}\n\n.ai_workshop .conatiner img {\n  height: 100% !important;\n  width: auto !important;\n}\n\n.ai-workshop-wrapper ul li {\n  text-align: justify;\n}\n\n.ai_workshop span {\n  display: inline-block;\n  font-weight: 600;\n  margin-bottom: 20px;\n  background-color: var(--dPink);\n  padding: 5px 15px;\n  color: #ffffff;\n}\n\n.school_form_submit button {\n  border: 0;\n  margin-top: 20px;\n  margin-bottom: 50px;\n  background: #5bbca5;\n  color: #ffffff;\n  padding: 10px 30px;\n  border-radius: 10px;\n  font-weight: 700;\n}\n\n.ai-workshop-wrapper h2 {\n  font-family: \"Nasalization\";\n  font-size: 40px;\n}\n\n@media (max-width: 576px) {\n  section.ai_workshop .container {\n    flex-direction: column;\n  }\n  .ai_workshop img {\n    width: 100%;\n  }\n  .ai_workshop img {\n    width: 100%;\n    object-fit: contain;\n  }\n\n  .pdp_banner {\n    padding: 0 5%;\n  }\n\n  .pdp_banner span,\n  .pdp_banner_subtxt {\n    font-size: 28px;\n  }\n\n  .tpdp-heading {\n    font-size: 22px;\n    padding-top: 20px;\n    padding-bottom: 0px;\n  }\n\n  .tpdp-content {\n    padding-left: 10px;\n  }\n\n  .waht_teacher_pdp {\n    padding: 5%;\n  }\n\n  .gpt_workshop {\n    padding: 3%;\n  }\n\n  section.ai_workshop {\n    padding: 5%;\n  }\n}\n\n@media (max-width: 820px) {\n  .ai_workshop img {\n    width: 100%;\n    object-fit: contain;\n  }\n\n  section.ai_workshop .container {\n    flex-wrap: wrap;\n  }\n\n  .waht_teacher_pdp img {\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .px-md-5 {\n    padding: 0px !important;\n  }\n\n  .pt-100 {\n    padding-top: 50px !important;\n  }\n\n  .teacher-pdp-form .form-control {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
